import { setAppState, setAppError } from "../../actions/App/dispatchers";
import { reset_all_regions } from "../../reducers/Regions/reducer";
import { fetch_all_regions_graphql } from "../../actions/Regions/dispatchers";
import * as CONSTANTS from "./constants";
import { fetch_tracking } from "../../actions/Tracking/dispatchers";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";

export const fetchNewsLocalData = (path) => (dispatch) => {
    dispatch(reset_app_state(path));
    dispatch(reset_all_regions());

    return dispatch(fetch_all_regions_graphql(CONSTANTS.ITEM_COUNT))
        .then(() => dispatch(fetch_tracking()))
        .then(() => dispatch(setAppState(path, false, "")))
        .catch((error) => {
            dispatch(setAppError(path, error.code));
        });
};
